import * as React from "react";
// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import {WidgetController} from "./WidgetController";

import "./WidgetsStyle.scss";
import {VeBoxCard} from "../../../../../../components/card/VeBoxCard";

export interface WidgetProps {
    key: any;
    controller: WidgetController;
    width: string;
}

export abstract class Widget<P extends WidgetProps, S> extends React.Component<P, S> {

    protected listener: Subscription;

    constructor(props: P) {
        super(props);
    }

    public render() {
        return (
            <div className={`${this.props.width} dashboard-widget f-grid-item`} key={this.props.key}>
                <div className="widget-content">
                    {this.widgetRender()}
                </div>
            </div>
        );
    }

    public componentWillUnmount() {
        if (this.listener) {
            this.listener.unsubscribe();
        }
    }

    public abstract widgetRender();
}
